<div class="page-header">
  <app-prev-next-button (click)="toIn()" [direction]="'left'" [label]="'documentos de entrada / triagem'"></app-prev-next-button>
  <h1>Triagem</h1>
  <app-prev-next-button (click)="toInspection()" [direction]="'right'" [label]="'conferência'"></app-prev-next-button>
</div>


